import { useNavigate, useSearch } from '@tanstack/react-router';
import { agencyRouteSearchSchema } from './agencyRouteSearch';

export function useAgencyRouteFilters() {
  const navigate = useNavigate({ from: '/campaigns/agencies' });
  const search = useSearch({ from: '/campaigns/agencies' });
  return {
    search: search.search ?? '',
    page: (search.page ?? 1) - 1,
    size: search.size ?? 20,
    setSearch: (value: string) => {
      void navigate({
        search: agencyRouteSearchSchema({ ...search, search: value, page: 1 }),
        replace: true,
      });
    },
    setPagination: (page: number, size: number) => {
      void navigate({
        search: agencyRouteSearchSchema({ ...search, page: page + 1, size }),
        replace: true,
      });
    },
  };
}
